export default "__VITE_ASSET__d2b53c4b__"